import React from "react"
import { useDispatch } from "react-redux"
import { setMargin } from "../Actions/Navigation.action"
import useIsMobile from "../Hooks/useIsMobile"
import { useScroll } from "../Hooks/useScroll"
import { translate } from "../Services/translation"

const HEADER_HEIGHT = 88
const HEADER_HEIGHT_MOBILE = 53

export default function ProductInfoNav(props) {
    const { sections } = props
    const [activeLink, setActiveLink] = React.useState()
    const [active, setIsActive] = React.useState(false)
    const scroll = useScroll(false)
    const ref = React.createRef()
    const dispatch = useDispatch()
    const isMobile = useIsMobile()
    const sectionElements = sections.map(s => s.element)

    React.useEffect(() => {
        if(ref && ref.current) {
            var headerHeight = document.querySelector("header").offsetHeight
            if(ref.current.getBoundingClientRect().top <= headerHeight) {
                dispatch(setMargin(-headerHeight + ref.current.getBoundingClientRect().top))
            }else{
                dispatch(setMargin(0))
            }

            if(ref.current.getBoundingClientRect().top <= 8) {
                dispatch(setMargin(-headerHeight))
                setIsActive(true)
            }else{
                setIsActive(false)
            }

            if(active) {
                for(var index = 0; index < sectionElements.length; index++) {
                    var section = sectionElements[index]
    
                    var yPos = section.getBoundingClientRect().y
                    var yPosEnd = yPos + section.offsetHeight
                    if(yPos <= HEADER_HEIGHT && yPosEnd > HEADER_HEIGHT) {
                        setActiveLink(section.id)
                    }
                }
            }else{
                setActiveLink(undefined)
            }
            
        }
    }, [scroll])

    React.useEffect(() => {
        var parent = ref.current.parentNode
        
        if(active && !parent.classList.contains("product-info-nav--active"))
            parent.classList.add("product-info-nav--active")
        else if(!active)
            parent.classList.remove("product-info-nav--active")
    }, [active])

    const getActiveClass = link => activeLink == link ? "active" : ""

    const onLinkClick = e => {
        e.preventDefault()

        var titleElemSelector = e.target.getAttribute("href")
        var titleElem = document.querySelector(titleElemSelector)
        var y = titleElem.getBoundingClientRect().top + window.pageYOffset - (!isMobile ? HEADER_HEIGHT : HEADER_HEIGHT_MOBILE)
        window.scrollTo({ top: y, behavior: 'smooth' })
    }

    return <div className="row product-info-nav__wrapper" ref={ref}>
        <div className="small-12 columns">
            {sections.map(section => <a key={section.id} href={"#"+section.id} onClick={onLinkClick} className={getActiveClass(section.id)}>{section.name}</a>)}
        </div>
    </div>
}